import React, { useMemo, useState, useEffect } from "react";
import SeoHead from "../components/SeoHead";
import { motion, AnimatePresence } from "framer-motion";
import { Filter, X, ZoomIn, ExternalLink, ChevronLeft, ChevronRight } from "lucide-react";
import HrefLangTags from "../components/HrefLangTags";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import { useLanguage } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";

// All 66 projeler images categorized
const ALL_WORKS = [
  // Sosyal Medya
  { src: "/projeler/postunhazir_1601024075_2405886777877030209_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1605276939_2441562387436557652_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1605277074_2441563519219314665_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1605277074_2441563519236130637_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1606913046_2455287053100397823_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1607584855_2460922588807569191_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602979922063622_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1608023591_2464602979938725771_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602979955505361_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602979972368368_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602979980636483_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1608023591_2464602979980740420_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1608023591_2464602979989152313_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602979997440520_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1608023591_2464602980005752129_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1608023591_2464602980047682976_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1614588010_2519669310313105740_40209662941.jpg", category: "creative", tag: "Ürün Tanıtımı" },
  { src: "/projeler/postunhazir_1614588580_2519674095023326629_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1616765752_2537937537052049310_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1616765804_2537937971573510931_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1622989333_2590144722873304604_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1622989333_2590144722881604298_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1622989379_2590145104454305162_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1622989379_2590145104470959793_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1624648067_2604059187763095369_40209662941.jpg", category: "creative", tag: "Ürün Tanıtımı" },
  { src: "/projeler/postunhazir_1630669540_2654570964358549412_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1630669540_2654570964392116991_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1638354658_2719038403112427336_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1653941918_2849793825201060510_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1659029845_2892474448432567894_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1659030820_2892482623701503894_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1678050666_3052032654119811187_40209662941.jpg", category: "creative", tag: "Ürün Tanıtımı" },
  { src: "/projeler/postunhazir_1678050666_3052032654128243176_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1678050666_3052032654145186984_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1689013937_3143999241440765373_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1689013937_3143999241457743521_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1694290596_3188263068092930172_40209662941.jpg", category: "sosyal", tag: "Turizm & Otel" },
  { src: "/projeler/postunhazir_1709195261_3313292454688755401_40209662941.jpg", category: "medikal", tag: "Medikal & Sağlık" },
  { src: "/projeler/postunhazir_1709195261_3313292454688858757_40209662941.jpg", category: "medikal", tag: "Medikal & Sağlık" },
  { src: "/projeler/postunhazir_1709195261_3313292454713886750_40209662941.jpg", category: "medikal", tag: "Medikal & Sağlık" },
  { src: "/projeler/postunhazir_1709195261_3313292454739286208_40209662941.jpg", category: "medikal", tag: "Medikal & Sağlık" },
  { src: "/projeler/postunhazir_1733155802_3514288033514426975_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1733156660_3514295231862953370_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1733213589_3514772789008061519_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1746275810_3624346644940226024_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1746275810_3624346644948494920_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1746275810_3624346644948544505_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1746276095_3624349039132822749_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1746276095_3624349039132905813_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1746276095_3624349039141175670_40209662941.jpg", category: "creative", tag: "Ürün Tanıtımı" },
  { src: "/projeler/postunhazir_1746276095_3624349039141178197_40209662941.jpg", category: "creative", tag: "Ürün Tanıtımı" },
  { src: "/projeler/postunhazir_1746276095_3624349039141189359_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1746276095_3624349039141196999_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776590460_3878642275056363847_40209662941.jpg", category: "sosyal", tag: "Turizm & Otel" },
  { src: "/projeler/postunhazir_1776700579_3879568085649630956_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1776700579_3879568085842552133_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776700579_3879568085943234112_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1776700579_3879568086127791690_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776700579_3879568086261997846_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1776700579_3879568086589130594_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776700579_3879568086647837934_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
  { src: "/projeler/postunhazir_1776700579_3879568086815659792_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776700579_3879568086891159749_40209662941.jpg", category: "creative", tag: "Kampanya" },
  { src: "/projeler/postunhazir_1776700579_3879568087201497490_40209662941.jpg", category: "sosyal", tag: "Sosyal Medya" },
  { src: "/projeler/postunhazir_1776791747_3880332871433880364_40209662941.jpg", category: "sosyal", tag: "Turizm & Otel" },
  { src: "/projeler/postunhazir_1776792574_3880339814173016193_40209662941.jpg", category: "creative", tag: "Kreatif Tasarım" },
];

const CATEGORIES = [
  { id: "all", label: { tr: "Tümü", en: "All" } },
  { id: "sosyal", label: { tr: "Sosyal Medya", en: "Social Media" } },
  { id: "creative", label: { tr: "Kreatif & Kampanya", en: "Creative & Campaign" } },
  { id: "medikal", label: { tr: "Medikal & Sağlık", en: "Medical & Health" } },
];

function LightboxModal({ image, onClose, onPrev, onNext, total, current }) {
  // Touch swipe support
  const touchStartX = React.useRef(null);

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 50) { dx < 0 ? onNext() : onPrev(); }
    touchStartX.current = null;
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-ink/92 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Counter */}
      <div className="absolute top-5 left-1/2 -translate-x-1/2 text-cream/60 text-sm z-10">
        {current} / {total}
      </div>
      {/* Close */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-cream z-10 transition-colors"
      >
        <X className="h-5 w-5" />
      </button>
      {/* Prev */}
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        className="absolute left-4 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-cream z-10 transition-colors"
        aria-label="Önceki"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>
      {/* Next */}
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        className="absolute right-4 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-cream z-10 transition-colors"
        aria-label="Sonraki"
      >
        <ChevronRight className="h-6 w-6" />
      </button>

      <motion.div
        key={image.src}
        initial={{ scale: 0.88, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.88, opacity: 0 }}
        transition={{ type: "spring", stiffness: 280, damping: 24 }}
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-2xl max-h-[88vh] w-full flex flex-col items-center"
      >
        <img
          src={image.src}
          alt={image.tag}
          className="w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl"
        />
        <div className="mt-3 rounded-full bg-white/10 text-cream text-xs px-4 py-1.5 font-medium">
          {image.tag}
        </div>
      </motion.div>
    </motion.div>
  );
}

export default function WorksIndexPage() {
  const { lang } = useLanguage();
  const [filter, setFilter] = useState("all");
  const [lightboxIdx, setLightboxIdx] = useState(null); // index into `filtered`

  const langKey = lang === "tr" ? "tr" : "en";
  const pageTitle = lang === "tr" ? "Çalışmalarımız" : "Our Work";
  const pageDesc = lang === "tr"
    ? "Yastık Medya'nın müşterileri için ürettiği 200+ projenin seçkisi."
    : "Selected works from 200+ projects produced by Yastık Medya.";

  const filtered = useMemo(() =>
    filter === "all" ? ALL_WORKS : ALL_WORKS.filter((w) => w.category === filter),
    [filter]
  );

  const openLightbox = (idx) => setLightboxIdx(idx);
  const closeLightbox = () => setLightboxIdx(null);
  const prevItem = () => setLightboxIdx((i) => (i > 0 ? i - 1 : filtered.length - 1));
  const nextItem = () => setLightboxIdx((i) => (i < filtered.length - 1 ? i + 1 : 0));

  return (
    <div className="min-h-screen bg-cream text-ink" data-testid="works-index-page">
      <SeoHead title={`${pageTitle} — Yastık Medya`} description={pageDesc} path={`/${lang}/works`} imageKey="works" lang={lang} />
      <HrefLangTags pathSuffix="works" />
      <Header />

      <main>
        {/* Hero header */}
        <section className="container-page pt-[8vh] pb-[4vh] sm:pt-[10vh]">
          <Reveal as="div" className="max-w-4xl">
            <span className="eyebrow">
              <span className="h-1 w-1 rounded-full bg-brand-pink" />
              {lang === "tr" ? "Portfolyo" : "Portfolio"}
            </span>
            <h1
              data-testid="works-page-title"
              className="mt-5 font-display font-extrabold tracking-tight text-ink leading-[0.95]"
              style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
            >
              {lang === "tr" ? (
                <>Markaları büyüten <span className="gold-foil-text">çalışmalar.</span></>
              ) : (
                <>Works that <span className="gold-foil-text">scale brands.</span></>
              )}
            </h1>
            <p className="mt-4 max-w-xl text-body-lg text-ink/60">
              {lang === "tr"
                ? `${ALL_WORKS.length}+ gerçek müşteri projesi. Sosyal medya yönetiminden kreatif kampanyalara kadar.`
                : `${ALL_WORKS.length}+ real client projects. From social media management to creative campaigns.`}
            </p>
          </Reveal>

          {/* Filter chips */}
          <Reveal as="div" delay={0.1} className="mt-8 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-ink/55 me-2">
              <Filter className="h-3.5 w-3.5" />
              {lang === "tr" ? "Filtre" : "Filter"}
            </span>
            {CATEGORIES.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => setFilter(c.id)}
                data-testid={`works-filter-${c.id}`}
                className={`rounded-full border px-4 py-1.5 text-xs uppercase tracking-[0.14em] transition-colors
                  ${filter === c.id
                    ? "bg-ink text-cream border-ink"
                    : "bg-white text-ink/70 border-ink/15 hover:border-ink/40 hover:text-ink"}`}
              >
                {c.label[langKey] || c.label.en}
                <span className="ml-1.5 opacity-60">
                  ({c.id === "all" ? ALL_WORKS.length : ALL_WORKS.filter(w => w.category === c.id).length})
                </span>
              </button>
            ))}
          </Reveal>
        </section>

        {/* Masonry photo grid with lazy loading */}
        <section className="container-page pb-section sm:pb-section-lg">
          {/* Loading skeleton — show when no images yet and showing all */}
          {ALL_WORKS.length === 0 ? (
            <div className="columns-2 sm:columns-3 lg:columns-4 gap-3 space-y-3">
              {Array.from({ length: 12 }).map((_, i) => (
                <div
                  key={i}
                  className={`break-inside-avoid rounded-2xl bg-mist animate-pulse ${
                    i % 3 === 0 ? "h-64" : i % 3 === 1 ? "h-48" : "h-56"
                  }`}
                  style={{ marginBottom: "12px" }}
                />
              ))}
            </div>
          ) : (
            <div className="columns-2 sm:columns-3 lg:columns-4 gap-3 space-y-3">
              {filtered.map((work, i) => (
                <div
                  key={work.src}
                  className="break-inside-avoid group relative overflow-hidden rounded-2xl cursor-zoom-in
                             border border-mist hover:border-brand-pink/40
                             transition-[border-color,transform,box-shadow] duration-300
                             hover:-translate-y-1 hover:shadow-card"
                  style={{ marginBottom: "12px" }}
                  onClick={() => openLightbox(i)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && openLightbox(i)}
                >
                  <img
                    src={work.src}
                    alt={work.tag}
                    loading="lazy"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105 block"
                  />
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/50 transition-colors duration-300 flex items-center justify-center pointer-events-none">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center gap-2">
                      <span className="h-10 w-10 rounded-full bg-white/90 flex items-center justify-center">
                        <ZoomIn className="h-5 w-5 text-ink" />
                      </span>
                      <span className="text-cream text-xs font-semibold bg-ink/70 backdrop-blur rounded-full px-3 py-1">
                        {work.tag}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {filtered.length === 0 && ALL_WORKS.length > 0 && (
            <div className="py-20 text-center text-ink/50">
              {lang === "tr" ? "Bu kategori için içerik bulunamadı." : "No content found for this category."}
            </div>
          )}
        </section>

        {/* Closing CTA */}
        <section className="container-page pb-section">
          <div className="rounded-3xl bg-ink text-cream p-10 sm:p-14 relative overflow-hidden">
            <div className="absolute -top-32 -right-20 h-[420px] w-[420px] rounded-full bg-brand-pink/30 blur-3xl pointer-events-none" />
            <div className="relative max-w-2xl">
              <span className="eyebrow text-cream/60">
                <span className="h-1 w-1 rounded-full bg-brand-pink" />
                {lang === "tr" ? "Sıradaki proje" : "Next project"}
              </span>
              <h2 className="mt-5 font-display text-display-2 font-semibold">
                {lang === "tr" ? (
                  <>Markanın sırası mı?<br/><span className="gold-foil-text">Konuşalım.</span></>
                ) : (
                  <>Your brand next?<br/><span className="gold-foil-text">Let's talk.</span></>
                )}
              </h2>
              <Link
                to={`/${lang}/contact`}
                className="btn-gold mt-8 inline-flex"
                data-testid="works-cta-contact"
              >
                {lang === "tr" ? "Brief gönder" : "Send a brief"}
                <ExternalLink className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxIdx !== null && filtered[lightboxIdx] && (
          <LightboxModal
            image={filtered[lightboxIdx]}
            onClose={closeLightbox}
            onPrev={prevItem}
            onNext={nextItem}
            total={filtered.length}
            current={lightboxIdx + 1}
          />
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}
